import { createSlice } from "@reduxjs/toolkit";

const customPaginationSlice = createSlice({
  name: "customPagination",
  initialState: {},
  reducers: {
    setCustomPagination: (state, action) => {
      const { key, page, page_size } = action.payload;

      if (!state[key]) {
        state[key] = { page: 1, page_size: 10 };
      }

      if (page !== undefined) state[key].page = page;
      if (page_size !== undefined) {
        state[key].page_size = page_size;
        if (page === undefined) state[key].page = 1;
      }
    },
    resetCustomPagination: (state, action) => {
      const key = action.payload;
      state[key] = { page: 1, page_size: 10 };
    },
  },
});

export const { setCustomPagination, resetCustomPagination } =
  customPaginationSlice.actions;

export const selectCustomPagination = (state, key) =>
  state.customPagination[key] || { page: 1, page_size: 10 };

export default customPaginationSlice.reducer;
